export default __webpack_public_path__ + "static/media/logo-blue.e4b54e0f.svg";